export default __webpack_public_path__ + "static/media/logo_v2_white.eec8b1e8.svg";